import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    auth: {
      main_page: {
        welcome: 'WELCOME',
        sign_in: 'SIGN_IN',
        sign_up: 'SIGN_UP',
      },
    },
  }));
}
